<template>
  <textarea
    :placeholder="placeholder"
    :value="modelValue"
    class="resize-none overflow-hidden w-full outline-none grow block placeholder:text-light-950/40 dark:placeholder:text-dark-50/50"
    :style="{
      ...(height ? { height: height + 'px' } : {}),
      color: 'inherit !important'
    }"
    :rows="rows"
    @input="onChange"
    ref="$input"
  />
</template>

<script lang="ts" setup>

const props = withDefaults(defineProps<{
  modelValue: string
  rows?: number
  max?: number
  maxHeight?: number
  placeholder?: string
}>(), {
  rows: 2,
  max: 99999,
  maxHeight: 99999
})

const emit = defineEmits<{
  (e: 'update:modelValue', v: string): void
}>()

const $input = ref()
const height = ref(0)
const minHeight = ref(0)

const onChange = () => {
  onResize()

  $input.value.value = $input.value.value.replaceAll('\n', '').slice(0, props.max)
  
  emit('update:modelValue', $input.value.value)
}

const onResize = () => {
  height.value = Math.min(minHeight.value, props.maxHeight)
  
  nextTick(() => height.value = Math.min($input.value.scrollHeight + 1, props.maxHeight))
}

onMounted(() => {
  minHeight.value = Math.min($input.value.scrollHeight, props.maxHeight)
  height.value = Math.min($input.value.scrollHeight + 1, props.maxHeight)
})

defineExpose({
  reset: onResize,
  focus: () => {
    if ($input.value) $input.value.focus()
  }
})
</script>